/**
 * Determines whether Automator should make the item ID visible for some items
 * This modifies UncannyAutomator.recipe.items to add the "shouldShowItemId" property
 *
 * @return {undefined}
 */
const flagItemsWithVisibleID = () => {
	// For now, only triggers can show IDs. Check if we should show it
	if ( recipeHasMultipleItemsSameIntegration() ) {
		// Iterate the items
		// eslint-disable-next-line no-unused-vars
		Object.keys( UncannyAutomator.recipe.items ).forEach( ( itemID ) => {
			// Add the property
			UncannyAutomator.recipe.items[ itemID ].shouldShowItemId = true;
		} );
	}
}

/**
 * Checks if the recipe has one of more item from the same integration
 * 
 * @retuns {Boolean}
 */
const recipeHasMultipleItemsSameIntegration = () => {
	// Get the items
	const items = Object.values( UncannyAutomator.recipe.items );

	// If there are less than two, don't show ID
	if ( items.length < 2 ) {
		return false;
	}

	// Get the list of integrations used in the recipe items
	const integrationsInItems = [
		// Remove the duplicates using Set
		// Ex: [ 'LD', 'WC', 'LD' ] ==> [ 'LD', 'WC' ]
		...new Set(
			// Create an array of integration codes. Ex: [ 'LD', 'WC', 'LD' ]
			items.map( item => item.integrationCode )
		)
	];

	// Check if there is more than one item from same integration
	// To check this, we will check if there are more items than integrations
	if ( integrationsInItems.length >= items.length ) {
		return false;
	}

	return true;
}

export default flagItemsWithVisibleID;
